<template>
  <div class="listenansichtContainer">
    <div class="header">
      <div class="content">
        <Select
          :selectOptions="layers.map(layer => layer.listenansicht.name)"
          :placeholder="'Listenansichtauswahl'"
          :icon="'icon_expand_more_grey'"
          :border="{color:'borderDarkGrey',top:true,bottom:true}"
          v-model="activeListenansichtOption"
          @change="setActiveListenansichtOption"
        />
        <div
          class="displayflex flexbetween cursor-pointer margin20_0"
          @click="filterextended = !filterextended"
          v-if="activeLayer[0].listenansicht.streets.length > 0"
        >
          <div class="displayflex">
            <SVGIcon name="filter"/>
            <div class="marginleft15 fontsize18 selfAlignCenter">Nach Straßen filtern</div>
          </div>
          <SVGIcon
            name="icon_expand_more"
            :class="['selfAlignCenter', filterextended ? 'rotate180' :'']"
          />
        </div>
        <div class="marginbottom15" v-if="filterextended">
          <ul class="list-inline">
            <li
              v-for="(streetObj, index) in activeLayer[0].listenansicht.streets"
              :key="index"
              :class="[getStreetType(streetObj.street), { 'inactive': checkStreetObjVisibility(streetObj)}]"
              @click="toggleStreetVisibility(streetObj.street, activeListenansichtOption)"
            >{{streetObj.street}}</li>
            <li
              v-if="checkAllDeactivate(activeLayer[0].listenansicht.streets)"
              @click="setAllListenansichtItems(activeListenansichtOption, false)"
            >alle deaktivieren</li>
            <li
              v-else
              @click="setAllListenansichtItems(activeListenansichtOption, true)"
            >alle aktivieren</li>
          </ul>
        </div>
      </div>
      <div style="margin-top:32.5px;" @click="closeSidebar">
        <SVGIcon name="close" size="small" class="cursor-pointer"/>
      </div>
    </div>
    <div class="list">
      <div
        class="row cursor-pointer marginbottom15"
        v-for="(feature,index) in visibleActiveLayerFeatures"
        :key="index"
        @click="setJumpTo(feature.geometry,activeLayer[0])"
      >
        <div class="listicon">
          <img
            v-if="activeLayer[0].icons.iconUrl(feature.properties).type === 'png'"
            :src="activeLayer[0].icons.iconUrl(feature.properties,true).data"
            class="icon"
          >
          <div
            class="svgicon"
            v-else
            v-html="activeLayer[0].icons.iconUrl(feature.properties,true).data"
            style="width:36px;height:36px"
          ></div>
        </div>
        <div class="listinfo">
          <div
            v-html="activeLayer[0].icons.popup({
            props:feature.properties,
            target:'Listenansicht',
            streettype:getStreetType(feature.properties.street)
            })"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from "./../CoreComponents/Select.vue";

export default {
  name: "Listenansicht",
  components: {
    Select
  },
  data: function() {
    return {
      filterextended: false
    };
  },
  methods: {
    setActiveListenansichtOption(value) {
      this.$store.commit("setActiveListenansichtOption", value);
      this.filterextended = false;
    },
    setJumpTo(geometry, layer) {
      this.$store.commit("setJumpTo", geometry);
      this.$store.commit("setLayerActive", { layerId: layer.id, active: true });
      // layer.active = true;
    },
    closeSidebar() {
      this.$emit("close");
    },
    // Anzeige / Ausblenden von Listenansicht Elementen bei Klick auf Straße im Header
    toggleStreetVisibility(street, layername) {
      this.$store.commit("toggleListenansichtVisibility", {
        layername,
        street
      });
    },
    setListenAnsichtStreets() {
      this.$store.commit("setListenAnsichtStreets");
    },
    setAllListenansichtItems(activeListenansichtOption, setTo) {
      this.$store.commit("setAllListenansichtItems", {
        activeListenansichtOption,
        setTo
      });
    },
    getStreetType(street) {
      const firstLetter = street.split("")[0];
      const streettype =
        firstLetter === "A"
          ? "highway"
          : firstLetter === "B"
          ? "road"
          : firstLetter === "L"
          ? "land"
          : firstLetter === "K"
          ? "kreis"
          : firstLetter === "E"
          ? "empty"
          : "";
      return "road-label " + streettype;
    },

    checkStreetObjVisibility(streetObj) {
      return (
        !typeof streetObj.visibility === "undefined" || !streetObj.visibility
      );
    },
    checkFeatureVisibility(feature) {
      if (typeof feature !== "object") return false;
      const arr = this.activeLayer[0].listenansicht.streets.filter(
        streetObj => streetObj.street === feature.properties.street
      );
      return arr[0].visibility;
    },
    checkAllDeactivate(streets) {
      return streets.filter(streetObj => streetObj.visibility).length !== 0;
    }
  },
  computed: {
    layers() {
      this.setListenAnsichtStreets();
      return this.$store.state.layers.filter(layer => !!layer.listenansicht);
    },
    activeLayer() {
      return this.layers.filter(
        layer => layer.listenansicht.name === this.activeListenansichtOption
      );
    },
    activeLayerFeatures() {
      return this.activeLayer.map(layer => layer.icons.data.features);
    },
    visibleActiveLayerFeatures() {
      return this.activeLayerFeatures[0].filter(feature =>
        this.checkFeatureVisibility(feature)
      );
    },
    device() {
      return this.$store.state.device;
    },
    activeListenansichtOption() {
      return this.$store.state.activeListenansichtOption;
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listenansichtContainer {
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.content {
  width: calc(10.75 / 12 * 100%);
}

.list-inline {
  padding-left: 0;
  margin-left: -5px;
  list-style: none;
}

.list-inline > li {
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
  margin: 4px 3px;
  cursor: pointer;
  font-size: 16px;
  font-family: "Droid Sans", sans-serif;
}
.road-label {
  width: 48px;
  height: 23px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  padding: 0px;
  margin: 0px;
  max-width: 50px;
}
.road-label.highway {
  background: #1a70b8;
  border: 1px solid #1a70b8;
  color: #ffffff;
}
.road-label.highway.inactive {
  background: #8f979b;
  border: 1px solid #8f979b;
}
.road-label.road {
  background: #fecb00;
  color: #525c61;
  border: 1px solid #525c61;
}
.road-label.road.inactive {
  background: #ffffff;
  color: #8f979b;
  border: 1px solid #8f979b;
}
.road-label.kreis {
  background: #fff;
  color: #333 !important;
  border: 1px solid #000;
  font-weight: normal !important;
}
.road-label.kreis.inactive {
  background: #fff;
  color: #ccc !important;
  border: 1px solid #8f979b;
  font-weight: normal !important;
}
.road-label.land {
  background: #fff;
  color: #333 !important;
  border: 1px solid #000;
}
.road-label.land.inactive {
  background: #fff;
  color: #ccc !important;
  border: 1px solid #8f979b;
}

.listicon {
  width: calc(2 / 12 * 100%);
}

.listinfo {
  width: calc(10 / 12 * 100%);
}

.row {
  width: calc(10 / 12 * 100%);
  display: flex;
  margin: 0;
  margin-bottom: 15px;
}
</style>
